/*
 * PV UV DataSet
 */
export var CompanyDataAnalysisDataSet;
(function (CompanyDataAnalysisDataSet) {
    CompanyDataAnalysisDataSet["TOTAL_COUNT"] = "total_count";
    CompanyDataAnalysisDataSet["USER_COUNT"] = "user_count";
})(CompanyDataAnalysisDataSet || (CompanyDataAnalysisDataSet = {}));
/*
 * 搜索入参时间颗粒度
 */
export var GRANULARITY;
(function (GRANULARITY) {
    GRANULARITY["DAY"] = "day";
    GRANULARITY["WEEK"] = "week";
    GRANULARITY["MONTH"] = "month";
})(GRANULARITY || (GRANULARITY = {}));
/*
 * 数据分析类型
 */
export var CompanyDataAnalysisKeyType;
(function (CompanyDataAnalysisKeyType) {
    CompanyDataAnalysisKeyType["ANALYTICS_SEARCH"] = "analytics_search";
    CompanyDataAnalysisKeyType["CONCURRENCY"] = "concurrency";
    CompanyDataAnalysisKeyType["COPILOT"] = "copilot";
    CompanyDataAnalysisKeyType["KICK_OUT_BY_SELF"] = "kick_out_by_self";
    CompanyDataAnalysisKeyType["ANALYTICS_CUSTOM_ANALYSIS"] = "analytics_custom_analysis";
    CompanyDataAnalysisKeyType["ANALYTICS_EMAIL_ALERT"] = "analytics_email_alert";
    CompanyDataAnalysisKeyType["ANALYTICS_EMAIL_ALERT_STATUS"] = "analytics_email_alert_status";
    CompanyDataAnalysisKeyType["EUREKA_SEARCH"] = "eureka_search";
    CompanyDataAnalysisKeyType["EUREKA_TECH_IDEA_SEARCH"] = "eureka_tech_idea_search";
    CompanyDataAnalysisKeyType["WORKSPACE_CREATED"] = "workspace_created";
    CompanyDataAnalysisKeyType["WORKSPACE_COOPERATION"] = "workspace_cooperation";
    CompanyDataAnalysisKeyType["WORKSPACE_LOGIN"] = "workspace_login";
    CompanyDataAnalysisKeyType["WORKSPACE_SHARE"] = "workspace_share";
    CompanyDataAnalysisKeyType["WORKSPACE_TAG"] = "workspace_tag";
    CompanyDataAnalysisKeyType["WORKSPACE_SUMMARY"] = "workspace_summary";
    CompanyDataAnalysisKeyType["COMPANY_NEW_USER"] = "company_new_user";
    CompanyDataAnalysisKeyType["BIO_NEW_USER"] = "bio_new_user";
    CompanyDataAnalysisKeyType["CHEMICAL_NEW_USER"] = "chemical_new_user";
    CompanyDataAnalysisKeyType["SYNAPSE_NEW_USER"] = "synapse_new_user";
    CompanyDataAnalysisKeyType["EUREKA_NEW_USER"] = "eureka_new_user";
    CompanyDataAnalysisKeyType["ANALYTICS_NEW_USER"] = "analytics_new_user";
    CompanyDataAnalysisKeyType["SYNAPSE_SEARCH"] = "synapse_search";
    CompanyDataAnalysisKeyType["EUREKA_AIR_TECH_SEEK"] = "eureka_air_tech_seek";
    CompanyDataAnalysisKeyType["EUREKA_AIR_TECH_MIND"] = "eureka_air_tech_mind";
    CompanyDataAnalysisKeyType["EUREKA_AIR_TECH_RESEARCH_CREATE"] = "eureka_air_tech_research_create";
    CompanyDataAnalysisKeyType["EUREKA_AIR_TECH_RESEARCH_VIEW"] = "eureka_air_tech_research_view";
    CompanyDataAnalysisKeyType["EUREKA_AIR_NEW_USER"] = "eureka_air_new_user";
    // eureka air 用户总结图表 reportName
    CompanyDataAnalysisKeyType["EUREKA_AIR_SUMMARY"] = "eureka_air_summary";
    // eureka 用户登录图表 reportName
    CompanyDataAnalysisKeyType["EUREKA_LOGIN"] = "eureka_login";
    // eureka 用户总结图表 reportName
    CompanyDataAnalysisKeyType["EUREKA_SUMMARY"] = "eureka_user_usage_list";
    CompanyDataAnalysisKeyType["EUREKA_RD_USAGE_REPORT"] = "eureka_rd_usage_report";
    CompanyDataAnalysisKeyType["EUREKA_IP_USAGE_REPORT"] = "eureka_ip_usage_report";
    CompanyDataAnalysisKeyType["EUREKA_MATERIALS_USAGE_REPORT"] = "eureka_materials_usage_report";
    // Connect 使用情况
    CompanyDataAnalysisKeyType["CONNECT_USAGE"] = "openapi_successful_called";
    CompanyDataAnalysisKeyType["CONNECT_ATTEMPTED"] = "openapi_attempted_called";
    CompanyDataAnalysisKeyType["CONNECT_USAGE_DETAIL"] = "connect_usage_detail";
})(CompanyDataAnalysisKeyType || (CompanyDataAnalysisKeyType = {}));
// reportName下的事件名称
export var CompanyDataAnalysisEventKey;
(function (CompanyDataAnalysisEventKey) {
    CompanyDataAnalysisEventKey["DATE"] = "date";
    CompanyDataAnalysisEventKey["SIMPLE_SEARCH"] = "simple_search";
    CompanyDataAnalysisEventKey["FIELD_SEARCH"] = "field_search";
    CompanyDataAnalysisEventKey["PROJECT_SEARCH"] = "project_search";
    CompanyDataAnalysisEventKey["BULK_SEARCH"] = "bulk_search";
    CompanyDataAnalysisEventKey["SEMANTIC_SEARCH"] = "semantic_search";
    CompanyDataAnalysisEventKey["EXPAND_SEARCH"] = "expand_search";
    CompanyDataAnalysisEventKey["IMAGE_SEARCH"] = "image_search";
    CompanyDataAnalysisEventKey["CLASSIFICATION_SEARCH"] = "classification_search";
    CompanyDataAnalysisEventKey["LEGAL_SEARCH"] = "legal_search";
    CompanyDataAnalysisEventKey["HEADER_SEARCH"] = "header_search";
    CompanyDataAnalysisEventKey["COMMAND_SEARCH"] = "command_search";
    CompanyDataAnalysisEventKey["CUSTOM_ANALYSIS"] = "custom_analysis";
    CompanyDataAnalysisEventKey["EMAIL_ALERT"] = "email_alert";
    CompanyDataAnalysisEventKey["EUREKA_SEARCH"] = "eureka_search";
    CompanyDataAnalysisEventKey["TECH_IDEA_SEARCH"] = "tech_idea_search";
    CompanyDataAnalysisEventKey["COMPANY"] = "company";
    CompanyDataAnalysisEventKey["PERSONAL"] = "personal";
    CompanyDataAnalysisEventKey["LOGIN"] = "login";
    CompanyDataAnalysisEventKey["SHARE"] = "share";
    CompanyDataAnalysisEventKey["RULE_TAG"] = "rule_tag";
    CompanyDataAnalysisEventKey["BATCH_TAG"] = "batch_tag";
    CompanyDataAnalysisEventKey["SINGLE_TAG"] = "single_tag";
    CompanyDataAnalysisEventKey["AI_TAG"] = "ai_tag";
    // FIXME 准备修改
    CompanyDataAnalysisEventKey["USER"] = "user";
    CompanyDataAnalysisEventKey["BIO"] = "bio";
    CompanyDataAnalysisEventKey["CHEMICAL"] = "chemical";
    CompanyDataAnalysisEventKey["ANALYTICS"] = "analytics";
    CompanyDataAnalysisEventKey["EUREKA"] = "eureka";
    CompanyDataAnalysisEventKey["EUREKA_AIR"] = "eureka_air";
    CompanyDataAnalysisEventKey["SYNAPSE"] = "synapse";
    CompanyDataAnalysisEventKey["NO_PERMISSION"] = "no_permission";
    CompanyDataAnalysisEventKey["BIO_NEW_TOTAL_USER"] = "bio_login_total_count";
    CompanyDataAnalysisEventKey["LOGIN_CNT"] = "login_cnt";
    CompanyDataAnalysisEventKey["LOGIN_ALL_CNT"] = "login_all_cnt";
    CompanyDataAnalysisEventKey["JOIN_DATE"] = "join_date";
    CompanyDataAnalysisEventKey["USER_INFO"] = "user_info";
    CompanyDataAnalysisEventKey["USER_ID"] = "user_id";
    CompanyDataAnalysisEventKey["JOB_TITLE"] = "job_title";
    CompanyDataAnalysisEventKey["CREATED_DATE"] = "created_date";
    CompanyDataAnalysisEventKey["PERMISSIONS"] = "permissions";
    CompanyDataAnalysisEventKey["INVALID_PERMISSIONS"] = "invalid_permissions";
    CompanyDataAnalysisEventKey["ACTIVE_SEARCH_CNT"] = "active_search_cnt";
    CompanyDataAnalysisEventKey["DETAIL_ALL_CNT"] = "detail_all_cnt";
    CompanyDataAnalysisEventKey["SYNAPSE_SUBMIT_APPLY_TRAIL_ACCOUNT_CNT"] = "synapse_submit_apply_trail_account_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_SEEK"] = "eureka_air_tech_seek";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_MIND"] = "eureka_air_tech_mind";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_RESEARCH_CREATE"] = "eureka_air_tech_research_create";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_RESEARCH_VIEW"] = "eureka_air_tech_research_view";
    CompanyDataAnalysisEventKey["EUREKA_AIR_NEW_USER"] = "eureka_air_new_user";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_SEEK_CNT"] = "eureka_air_tech_seek_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_RESEARCH_VIEW_CNT"] = "eureka_air_tech_research_view_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_RESEARCH_TOTAL_CNT"] = "eureka_air_tech_research_total_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_RESEARCH_CREATE_CNT"] = "eureka_air_tech_research_create_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_TECH_MIND_CNT"] = "eureka_air_tech_mind_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_LOGIN_CNT"] = "eureka_air_login_cnt";
    CompanyDataAnalysisEventKey["EUREKA_AIR_LOGIN_ALL_CNT"] = "eureka_air_login_all_cnt";
    CompanyDataAnalysisEventKey["EUREKA_LOGIN_CNT"] = "eureka_login_cnt";
    CompanyDataAnalysisEventKey["EUREKA_LOGIN_ALL_CNT"] = "eureka_login_all_cnt";
    CompanyDataAnalysisEventKey["EUREKA_LOGIN_DAYS"] = "eureka_login_days";
    // RD
    CompanyDataAnalysisEventKey["EUREKA_RD_TECHNICAL_QA"] = "technical_qa";
    CompanyDataAnalysisEventKey["EUREKA_RD_FIND_SOLUTION"] = "find_solution";
    CompanyDataAnalysisEventKey["EUREKA_RD_QUICK_RESEARCH"] = "quick_research";
    CompanyDataAnalysisEventKey["EUREKA_RD_EVALUATE_FEASIBILITY"] = "evaluate_feasibility";
    CompanyDataAnalysisEventKey["EUREKA_RD_FEASIBILITY_ANALYSIS_ASSISTANT"] = "feasibility_analysis_assistant";
    CompanyDataAnalysisEventKey["EUREKA_RD_HOMEPAGE_SEARCH"] = "homepage_search";
    CompanyDataAnalysisEventKey["EUREKA_RD_PATENT_SEARCH"] = "rd_patent_search";
    CompanyDataAnalysisEventKey["EUREKA_RD_LITERATURE_SEARCH"] = "rd_paper_search";
    CompanyDataAnalysisEventKey["EUREKA_RD_IDEA_VALIDATION"] = "rd_novelty_check";
    CompanyDataAnalysisEventKey["EUREKA_RD_INVENTION_DISCLOSURE"] = "rd_ai_disclosure";
    // IP
    CompanyDataAnalysisEventKey["EUREKA_IP_NOVELTY_SEARCH"] = "novelty_search";
    CompanyDataAnalysisEventKey["EUREKA_IP_NOVELTY_SEARCH_SUCCESS"] = "novelty_search_success";
    CompanyDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFTING_CN"] = "specification_cn";
    CompanyDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFTING_US"] = "specification_us";
    CompanyDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFTING_EU"] = "specification_eu";
    CompanyDataAnalysisEventKey["EUREKA_IP_PATENT_TRANSLATION"] = "patent_translation";
    CompanyDataAnalysisEventKey["EUREKA_IP_DESIGN_FTO_SEARCH"] = "design_fto_search";
    CompanyDataAnalysisEventKey["EUREKA_IP_DESIGN_FTO_SEARCH_SUCCESS"] = "design_fto_search_success";
    CompanyDataAnalysisEventKey["EUREKA_IP_FTO_SEARCH"] = "fto_search";
    CompanyDataAnalysisEventKey["EUREKA_IP_FTO_SEARCH_SUCCESS"] = "fto_search_success";
    CompanyDataAnalysisEventKey["EUREKA_IP_INVENTION_DISCLOSURE_SUCCESS"] = "invention_disclosure_success";
    CompanyDataAnalysisEventKey["EUREKA_IP_PATENT_DRAFT_SUCCESS"] = "patent_draft_success";
    CompanyDataAnalysisEventKey["EUREKA_IP_PROSECUTION_SUCCESS"] = "prosecution_success";
    // Materials
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_MATERIAL_PERFORMANCE_ANALYSIS"] = "material_performance_analysis";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_ALLOY_COMPOSITION_ANALYSIS"] = "alloy_composition_analysis";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_MULTI_D_SEARCH"] = "multi_d_search";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_SUBSTANCE_INQUIRY"] = "substance_inquiry";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_STRUCTURE_SEARCH"] = "structure_search";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_MATERIAL_SYNTHESIS_PROCESS"] = "material_synthesis_process";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_MATERIAL_PROFILE_SEARCH"] = "material_profile_search";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_COMPOSITION_SEARCH"] = "composition_search";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_SMART_SEARCH_PATENT"] = "ms_patent_search";
    CompanyDataAnalysisEventKey["EUREKA_MATERIALS_SMART_SEARCH_LITERATURE"] = "ms_paper_search";
    // 专利详情查看
    CompanyDataAnalysisEventKey["EUREKA_PATENT_VIEW"] = "patent_view";
    // 文献详情查看
    CompanyDataAnalysisEventKey["EUREKA_PAPER_VIEW"] = "paper_view";
    // Connect 计费类型
    CompanyDataAnalysisEventKey["PREPAID"] = "prepaid";
    CompanyDataAnalysisEventKey["FIXED"] = "fixed";
})(CompanyDataAnalysisEventKey || (CompanyDataAnalysisEventKey = {}));
// workspace DashBoard Key
export var CompanyDataAnalysisWorkspaceDashBoardKey;
(function (CompanyDataAnalysisWorkspaceDashBoardKey) {
    CompanyDataAnalysisWorkspaceDashBoardKey["PATENT_CNT"] = "patent_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["TOTAL_WORKSPACE_CNT"] = "total_workspace_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["COMPANY_WORKSPACE_CNT"] = "company_workspace_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["PERSONAL_WORKSPACE_CNT"] = "personal_workspace_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["COOPERATIVE_COMPANY_WORKSPACE_CNT"] = "cooperative_company_workspace_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["COOPERATIVE_PERSONAL_WORKSPACE_CNT"] = "cooperative_personal_workspace_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["CUSTOM_FIELD_TOTAL_CNT"] = "custom_field_total_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["COMPANY_CUSTOM_FIELD_TOTAL_CNT"] = "company_custom_field_total_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["PERSONAL_CUSTOM_FIELD_TOTAL_CNT"] = "personal_custom_field_total_cnt";
    CompanyDataAnalysisWorkspaceDashBoardKey["LAST_WEEK_EUREKA_AIR_NEW_USER_COUNT"] = "last_week_eureka_air_new_user_count";
    CompanyDataAnalysisWorkspaceDashBoardKey["LAST_MONTH_EUREKA_AIR_NEW_USER_COUNT"] = "last_month_eureka_air_new_user_count";
    CompanyDataAnalysisWorkspaceDashBoardKey["TOTAL_EUREKA_AIR_COUNT"] = "total_eureka_air_count";
    CompanyDataAnalysisWorkspaceDashBoardKey["LAST_WEEK_EUREKA_NEW_USER_COUNT"] = "last_week_eureka_new_user_count";
    CompanyDataAnalysisWorkspaceDashBoardKey["LAST_MONTH_EUREKA_NEW_USER_COUNT"] = "last_month_eureka_new_user_count";
    CompanyDataAnalysisWorkspaceDashBoardKey["TOTAL_EUREKA_COUNT"] = "total_eureka_count";
})(CompanyDataAnalysisWorkspaceDashBoardKey || (CompanyDataAnalysisWorkspaceDashBoardKey = {}));
